import { a as o, j as e } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { IonButton as w } from "@ionic/react";
import { translate as a } from "../../../../string-table.js";
import { Colors as h } from "../../../../1-foundations/Colors/Colors.js";
import { s as f, I as s } from "../../../../../Icon-D8QUNSZR.js";
import { J as W, K as B, A as C } from "../../../../../FeatureFlagProvider-BBppjvNP.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as E } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/ContactInfo.css';const T = "_contactInfo_udl9g_1", x = "_swingHeroWrapper_udl9g_7", P = "_swingHeroBanner_udl9g_17", H = "_profileImgWrapper_udl9g_30", A = "_profileImg_udl9g_30", b = "_editButtonWrapper_udl9g_44", y = "_editButton_udl9g_44", O = "_editIconWrapper_udl9g_59", S = "_contactInfoContent_udl9g_64", F = "_contactName_udl9g_72", L = "_email_udl9g_84", r = {
  contactInfo: T,
  swingHeroWrapper: x,
  swingHeroBanner: P,
  profileImgWrapper: H,
  profileImg: A,
  editButtonWrapper: b,
  editButton: y,
  editIconWrapper: O,
  contactInfoContent: S,
  contactName: F,
  "flex-row-center": "_flex-row-center_udl9g_78",
  email: L
};
function X(I) {
  const {
    email: p,
    editable: n,
    name: i,
    phoneNumber: t,
    profileImageUrl: l,
    isPhoneNumberVerified: N = !1,
    badge: d,
    isSwingHero: c = !1,
    children: u
  } = I, m = t ? W({
    phoneNumber: t
  }) : "", _ = t ? m.length > 10 ? t : B({
    phoneNumber: m
  }).value : void 0, g = () => /* @__PURE__ */ o("div", {
    className: r.swingHeroBanner,
    children: [/* @__PURE__ */ e("span", {
      children: a("SUB_PROFILE_CONTACT_SWING")
    }), /* @__PURE__ */ e(s, {
      name: "Swing Hero"
    }), /* @__PURE__ */ e("span", {
      children: a("SUB_PROFILE_CONTACT_HERO")
    })]
  }), v = () => /* @__PURE__ */ o("div", {
    className: r.contactInfoContent,
    children: [i && /* @__PURE__ */ e("div", {
      className: r.contactName,
      children: /* @__PURE__ */ e("span", {
        children: i
      })
    }), t && /* @__PURE__ */ o("div", {
      className: r["flex-row-center"],
      children: [/* @__PURE__ */ e("div", {
        style: d ? {
          alignSelf: "flex-start"
        } : {},
        children: /* @__PURE__ */ e(s, {
          name: "Phone"
        })
      }), /* @__PURE__ */ o("div", {
        children: [/* @__PURE__ */ e("span", {
          style: {
            color: h.black
          },
          children: _
        }), !N && _ && d && /* @__PURE__ */ e("div", {
          style: {
            marginTop: "4px"
          },
          children: d
        })]
      })]
    }), p && /* @__PURE__ */ o("div", {
      className: r["flex-row-center"],
      children: [/* @__PURE__ */ e(s, {
        name: "Mail"
      }), /* @__PURE__ */ e("span", {
        className: r.email,
        children: p
      })]
    })]
  });
  return /* @__PURE__ */ o(E, {
    title: "",
    onEditClick: n != null && n.isEditable ? n.onEditPhoneNumber : void 0,
    children: [/* @__PURE__ */ o("div", {
      className: r.contactInfo,
      style: {
        marginTop: n != null && n.isEditable ? "-24px" : 0
      },
      children: [/* @__PURE__ */ o("div", {
        style: {
          width: 92,
          position: "relative"
        },
        children: [l ? c ? /* @__PURE__ */ o("div", {
          className: r.swingHeroWrapper,
          children: [/* @__PURE__ */ e("div", {
            className: r.profileImgWrapper,
            children: /* @__PURE__ */ e("img", {
              src: l,
              alt: i,
              className: r.profileImg
            })
          }), /* @__PURE__ */ e(g, {})]
        }) : /* @__PURE__ */ e("div", {
          className: r.profileImgWrapper,
          children: /* @__PURE__ */ e("img", {
            src: l,
            alt: i,
            className: r.profileImg
          })
        }) : c ? /* @__PURE__ */ o("div", {
          className: r.swingHeroWrapper,
          children: [/* @__PURE__ */ e("div", {
            className: r.profileImgWrapper,
            children: /* @__PURE__ */ e("img", {
              src: f,
              alt: a("SUB_PROFILE_CONTACT_IMAGE_ALT"),
              style: {
                width: 92
              }
            })
          }), /* @__PURE__ */ e(g, {})]
        }) : /* @__PURE__ */ e("img", {
          src: f,
          alt: a("SUB_PROFILE_CONTACT_IMAGE_ALT"),
          style: {
            width: 92
          }
        }), (n == null ? void 0 : n.isEditable) && /* @__PURE__ */ e("div", {
          className: r.editButtonWrapper,
          style: c ? {
            bottom: "10px",
            right: "-14px"
          } : {},
          children: /* @__PURE__ */ e(w, {
            className: r.editButton,
            size: "small",
            shape: "round",
            onClick: n.onEditAvatar,
            children: /* @__PURE__ */ e("div", {
              className: r.editIconWrapper,
              children: /* @__PURE__ */ e(s, {
                name: "Edit",
                color: h.white200
              })
            })
          })
        })]
      }), (i || p || t) && /* @__PURE__ */ e(v, {})]
    }), !l && /* @__PURE__ */ e("div", {
      style: {
        marginTop: c ? "20px" : "8px"
      },
      children: /* @__PURE__ */ e(C, {
        color: "warning",
        children: a("SUB_PROFILE_NO_IMAGE_TEXT")
      })
    }), u]
  });
}
export {
  X as ContactInfo
};
